import React from 'react';
import ContactForm from './ContactForm';
import { useLanguage } from '../context/LanguageContext';

const ContactSection = () => {
  const { t } = useLanguage();
  return (
    <section id="contact" className="py-16 bg-blue-700 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="fade-in">
            <h2 className="text-3xl font-normal mb-4">{t('contact.sectionTitle')}</h2>
            <p className="opacity-90 leading-relaxed mb-4">
              {t('contact.desc1')}
            </p>
            <p className="opacity-90 leading-relaxed">
              {t('contact.desc2')}
            </p>
          </div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;